<template>
  <div class="row">
    <div class="col-xl-8">
      <div class="row">
        <!-- Services -->
        <div class="col-12" v-if="crmType === 'payroll'">
          <b-card header="Services" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
            <div class="row">
              <div class="col-xl-6">
                <div class="row">
                  <!-- Genius Tax -->
                  <div class="col-12 form-group">
                    <label class="form-label" for="genius_tax">Genius Tax</label>
                    <p id="genius_tax">
                      <span v-if="worker.rel_services.genius_tax">Yes</span>
                      <span v-else>No</span>
                    </p>
                  </div>
                  <div class="col-12 form-group" v-if="worker.rel_services.genius_tax">
                    <strong class="d-block">GENIUS TAX STATUS</strong>
                    <div class="row">
                      <div class="col-lg-8">Self Assessment Declaration</div>
                      <div class="col-lg-4">
                <span v-if="notEmptyObject(tax_hmrc) && tax_hmrc.received_self_ass_dec_form_date !== null" style="color: #36a266">
                  {{ tax_hmrc.received_self_ass_dec_form_date | formatDate }}
                </span>
                        <span v-else><i class="fas fa-times" style="color: #CC231F"></i></span>
                      </div>
                      <div class="col-lg-8">Terms of Engagement</div>
                      <div class="col-lg-4">
                <span v-if="notEmptyObject(tax_hmrc) && tax_hmrc.received_terms_engagement_date !== null" style="color: #36a266">
                  {{ tax_hmrc.received_terms_engagement_date | formatDate }}
                </span>
                        <span v-else><i class="fas fa-times" style="color: #CC231F"></i></span>
                      </div>
                      <div class="col-lg-8">HMRC 64/8</div>
                      <div class="col-lg-4">
                <span v-if="notEmptyObject(tax_hmrc) && tax_hmrc.received_hmrc_648_date !== null" style="color: #36a266">
                  {{ tax_hmrc.received_hmrc_648_date | formatDate }}
                </span>
                        <span v-else><i class="fas fa-times" style="color: #CC231F"></i></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="row">
                  <!-- Recruitment -->
                  <div class="col-12 form-group">
                    <label class="form-label" for="recruitment_service">Recruitment/Resourcing</label>
                    <p id="recruitment_service">
                      <span v-if="worker.rel_services.recruitment">Yes</span>
                      <span v-else>No</span>
                    </p>
                  </div>
                  <!-- Personal Accident Insurance -->
                  <div class="col-12 form-group">
                    <label class="form-label" for="personal_accident_insurance">Personal Accident Insurance</label>
                    <p id="personal_accident_insurance">
              <span v-if="worker.rel_services.personal_accident_insurance">
                Yes<br>
                <span style="font-size: 0.65rem;">An Additional charge of {{ pa_ins | currency }} is made per week</span>
              </span>
                      <span v-else>No</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
        <!-- Compliance Status -->
        <div class="col-12">
          <b-card header="Compliance Status" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
            <div class="row">
              <!-- Right to Work -->
              <div class="col-xl-6">
                <div class="row">
                  <!-- Identification -->
                  <div class="col-12">
                    <h4>Right to work</h4>
                  </div>
                  <div class="col-12 form-group" v-if="worker.person.is_uk_citizen">
                    <div class="uk_citizen">UK CITIZEN</div>
                  </div>
                  <div class="col-12 form-group" v-if="worker.person.nationality_id !== null">
                    <div class="nation" v-if="eu.includes(worker.person.nationality.country_name)">EU</div>
                    <div class="nation" v-else-if="uk_ireland.includes(worker.person.nationality.country_name)">UK</div>
                    <div class="nation" v-else>I</div>
                    <div class="d-inline-block">
                      <label class="form-label" for="nationality">Nationality</label>
                      <p id="nationality">
                        <span v-if="worker.person.nationality_id !== null">{{ worker.person.nationality.nationality }}</span>
                        <span v-else>&nbsp;</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-12" v-if="worker.person.nationality_id !== null">
                    <div v-if="eu.includes(worker.person.nationality.country_name) && !worker.person.is_uk_citizen">
                      <!-- Proof of ID -->
                      <div class="form-group">
                        <h5 class="mb-0">Proof of ID</h5>
                        <!-- Passport -->
                        <div v-if="files.filter(f => f.file_master_type_id === 27).length > 0" class="r2w">
                          <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 27)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                            <i class="fas fa-eye"></i>
                          </button>
                          <div v-if="files.filter(f => f.file_master_type_id === 27)[0].document_expiry_date !== null" class="d-inline-block align-middle cs_file_name"
                               :class="[this.$moment.utc(files.filter(f => f.file_master_type_id === 27)[0].document_expiry_date).isBefore() ? 'red_color' : '']">
                            Passport (Expires:&nbsp;{{ files.filter(f => f.file_master_type_id === 27)[0].document_expiry_date | formatDate }})<br>
                            <span v-if="this.$moment.utc(files.filter(f => f.file_master_type_id === 27)[0].document_expiry_date).isBefore()" class="red_color font-weight-bold">
                              EXPIRED
                            </span>
                          </div>
                          <div v-else class="d-inline-block align-middle cs_file_name">Passport</div>
                        </div>
                        <div v-else class="r2w red_color font-weight-bold cs_file_name">MISSING</div>
                      </div>
                      <!-- Proof of Address -->
                      <div class="form-group">
                        <h5 class="mb-0">Proof of Address</h5>
                        <!-- Address Document -->
                        <div v-if="files.filter(f => f.file_master_type_id === 28).length > 0" class="r2w">
                          <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 28)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                            <i class="fas fa-eye"></i>
                          </button>
                          <div class="d-inline-block align-middle cs_file_name">Address Document</div>
                        </div>
                        <!-- Drivers Licence Front & Back -->
                        <div v-else-if="files.filter(f => f.file_master_type_id === 29).length > 0" class="r2w">
                          <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 29)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                            <i class="fas fa-eye"></i>
                          </button>
                          <div v-if="files.filter(f => f.file_master_type_id === 29)[0].document_expiry_date !== null" class="d-inline-block align-middle cs_file_name"
                               :class="[this.$moment.utc(files.filter(f => f.file_master_type_id === 29)[0].document_expiry_date).isBefore() ? 'red_color' : '']">
                            Drivers Licence Front & Back (Expires:&nbsp;{{ files.filter(f => f.file_master_type_id === 29)[0].document_expiry_date | formatDate }})<br>
                            <span v-if="this.$moment.utc(files.filter(f => f.file_master_type_id === 29)[0].document_expiry_date).isBefore()" class="red_color font-weight-bold">
                              EXPIRED
                            </span>
                          </div>
                          <div v-else class="d-inline-block align-middle cs_file_name">Drivers Licence Front & Back</div>
                        </div>
                        <!-- Drivers Licence Front / Back -->
                        <div v-else-if="files.filter(f => f.file_master_type_id === 25).length > 0 || files.filter(f => f.file_master_type_id === 26).length > 0" class="r2w">
                          <!-- Front -->
                          <div class="r2w" v-if="files.filter(f => f.file_master_type_id === 25).length > 0">
                            <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 25)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div v-if="files.filter(f => f.file_master_type_id === 25)[0].document_expiry_date !== null" class="d-inline-block align-middle cs_file_name"
                                 :class="[this.$moment.utc(files.filter(f => f.file_master_type_id === 25)[0].document_expiry_date).isBefore() ? 'red_color' : '']">
                              Drivers Licence Front (Expires:&nbsp;{{ files.filter(f => f.file_master_type_id === 25)[0].document_expiry_date | formatDate }})<br>
                              <span v-if="this.$moment(files.filter(f => f.file_master_type_id === 25)[0].document_expiry_date).isBefore()" class="red_color font-weight-bold">
                              EXPIRED
                            </span>
                            </div>
                            <div v-else class="d-inline-block align-middle cs_file_name">Drivers Licence Front</div>
                          </div>
                          <div v-else class="r2w red_color">
                            <button @click.prevent="" class="btn orcaBtn grey_bg sm_btn r2w_btn disabled" disabled="disabled">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div class="d-inline-block align-middle cs_file_name">Drivers Licence Front<br>MISSING</div>
                          </div>
                          <!-- Back -->
                          <div class="r2w" v-if="files.filter(f => f.file_master_type_id === 26).length > 0">
                            <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 26)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div v-if="files.filter(f => f.file_master_type_id === 26)[0].document_expiry_date !== null" class="d-inline-block align-middle cs_file_name"
                                 :class="[this.$moment(files.filter(f => f.file_master_type_id === 26)[0].document_expiry_date).isBefore() ? 'red_color' : '']">
                              Drivers Licence Back (Expires:&nbsp;{{ files.filter(f => f.file_master_type_id === 26)[0].document_expiry_date | formatDate }})<br>
                              <span v-if="this.$moment(files.filter(f => f.file_master_type_id === 26)[0].document_expiry_date).isBefore()" class="red_color font-weight-bold">
                              EXPIRED
                            </span>
                            </div>
                            <div v-else class="d-inline-block align-middle cs_file_name">Drivers Licence Back</div>
                          </div>
                          <div v-else class="r2w red_color">
                            <button @click.prevent="" class="btn orcaBtn grey_bg sm_btn r2w_btn disabled" disabled="disabled">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div class="d-inline-block align-middle cs_file_name">Drivers Licence Back<br>MISSING</div>
                          </div>
                        </div>
                        <div v-else class="r2w red_color font-weight-bold">MISSING</div>
                      </div>
                      <div class="form-group">
                        <h5 class="mb-0">Proof of Settlement Status</h5>
                        <!-- Settlement Doc -->
                        <div v-if="files.filter(f => f.file_master_type_id === 23).length > 0" class="r2w">
                          <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 23)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                            <i class="fas fa-eye"></i>
                          </button>
                          <div v-if="files.filter(f => f.file_master_type_id === 23)[0].settlement_indefinite" class="d-inline-block align-middle cs_file_name">
                            Settlement Doc (Indefinite Stay)
                          </div>
                          <div v-else-if="files.filter(f => f.file_master_type_id === 23)[0].settlement_expiry !== null" class="d-inline-block align-middle cs_file_name"
                               :class="[this.$moment(files.filter(f => f.file_master_type_id === 23)[0].settlement_expiry).isBefore() ? 'red_color' : '']">
                            Settlement Doc (Expires:&nbsp;{{ files.filter(f => f.file_master_type_id === 23)[0].settlement_expiry | formatDate }})<br>
                            <span v-if="this.$moment(files.filter(f => f.file_master_type_id === 23)[0].settlement_expiry).isBefore()" class="red_color font-weight-bold">
                              EXPIRED
                            </span>
                          </div>
                        </div>
                        <div v-else class="r2w red_color font-weight-bold">MISSING</div>
                      </div>
                    </div>
                    <div v-else-if="uk_ireland.includes(worker.person.nationality.country_name) || worker.person.is_uk_citizen">
                      <div class="form-group">
                        <h5 class="mb-0">Proof of ID</h5>
                        <!-- Passport -->
                        <div v-if="files.filter(f => f.file_master_type_id === 27).length > 0" class="r2w">
                          <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 27)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                            <i class="fas fa-eye"></i>
                          </button>
                          <div v-if="files.filter(f => f.file_master_type_id === 27)[0].document_expiry_date !== null" class="d-inline-block align-middle cs_file_name"
                               :class="[this.$moment(files.filter(f => f.file_master_type_id === 27)[0].document_expiry_date).isBefore() ? 'red_color' : '']">
                            Passport (Expires:&nbsp;{{ files.filter(f => f.file_master_type_id === 27)[0].document_expiry_date | formatDate }})<br>
                            <span v-if="this.$moment(files.filter(f => f.file_master_type_id === 27)[0].document_expiry_date).isBefore()" class="red_color font-weight-bold">
                              EXPIRED
                            </span>
                          </div>
                          <div v-else class="d-inline-block align-middle cs_file_name">Passport</div>
                        </div>
                        <!-- Birth Certificate & Proof of NI -->
                        <div v-else-if="files.filter(f => f.file_master_type_id === 21).length > 0 || files.filter(f => f.file_master_type_id === 22).length > 0">
                          <!-- Birth Certificate -->
                          <div class="r2w" v-if="files.filter(f => f.file_master_type_id === 21).length > 0">
                            <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 21)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div class="r2w red_color">Birth Certificate</div>
                          </div>
                          <div v-else class="r2w red_color">
                            <button @click.prevent="" class="btn orcaBtn grey_bg sm_btn r2w_btn disabled" disabled="disabled">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div class="d-inline-block align-middle cs_file_name">Biometric ID Front<br>MISSING</div>
                          </div>
                          <!-- NI Number -->
                          <div class="r2w" v-if="files.filter(f => f.file_master_type_id === 22).length > 0">
                            <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 22)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div class="d-inline-block align-middle cs_file_name">Proof of NI</div>
                          </div>
                          <div v-else class="r2w red_color">
                            <button @click.prevent="" class="btn orcaBtn grey_bg sm_btn r2w_btn disabled" disabled="disabled">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div class="d-inline-block align-middle cs_file_name">Biometric ID Back<br>MISSING</div>
                          </div>
                          <div v-else class="r2w red_color font-weight-bold">MISSING</div>
                        </div>
                        <div v-else class="r2w red_color font-weight-bold">MISSING</div>
                      </div>
                      <div class="form-group">
                        <h5 class="mb-0">Proof of Address</h5>
                        <!-- Address Document -->
                        <div v-if="files.filter(f => f.file_master_type_id === 28).length > 0" class="r2w">
                          <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 28)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                            <i class="fas fa-eye"></i>
                          </button>
                          <div class="d-inline-block align-middle cs_file_name">Address Document</div>
                        </div>
                        <!-- Drivers Licence Front & Back -->
                        <div v-else-if="files.filter(f => f.file_master_type_id === 29).length > 0" class="r2w">
                          <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 29)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                            <i class="fas fa-eye"></i>
                          </button>
                          <div v-if="files.filter(f => f.file_master_type_id === 29)[0].document_expiry_date !== null" class="d-inline-block align-middle cs_file_name"
                               :class="[this.$moment(files.filter(f => f.file_master_type_id === 29)[0].document_expiry_date).isBefore() ? 'red_color' : '']">
                            Drivers Licence Front & Back (Expires:&nbsp;{{ files.filter(f => f.file_master_type_id === 29)[0].document_expiry_date | formatDate }})<br>
                            <span v-if="this.$moment(files.filter(f => f.file_master_type_id === 29)[0].document_expiry_date).isBefore()" class="red_color font-weight-bold">
                              EXPIRED
                            </span>
                          </div>
                          <div v-else class="d-inline-block align-middle cs_file_name">Drivers Licence Front & Back</div>
                        </div>
                        <!-- Drivers Licence Front / Back -->
                        <div v-else-if="files.filter(f => f.file_master_type_id === 25).length > 0 || files.filter(f => f.file_master_type_id === 26).length > 0" class="r2w">
                          <!-- Front -->
                          <div class="r2w" v-if="files.filter(f => f.file_master_type_id === 25).length > 0">
                            <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 25)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div v-if="files.filter(f => f.file_master_type_id === 25)[0].document_expiry_date !== null" class="d-inline-block align-middle cs_file_name"
                                 :class="[this.$moment(files.filter(f => f.file_master_type_id === 25)[0].document_expiry_date).isBefore() ? 'red_color' : '']">
                              Drivers Licence Front (Expires:&nbsp;{{ files.filter(f => f.file_master_type_id === 25)[0].document_expiry_date | formatDate }})<br>
                              <span v-if="this.$moment(files.filter(f => f.file_master_type_id === 25)[0].document_expiry_date).isBefore()" class="red_color font-weight-bold">
                              EXPIRED
                            </span>
                            </div>
                            <div v-else class="d-inline-block align-middle cs_file_name">Drivers Licence Front</div>
                          </div>
                          <div v-else class="r2w red_color">
                            <button @click.prevent="" class="btn orcaBtn grey_bg sm_btn r2w_btn disabled" disabled="disabled">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div class="d-inline-block align-middle cs_file_name">Drivers Licence Front<br>MISSING</div>
                          </div>
                          <!-- Back -->
                          <div class="r2w" v-if="files.filter(f => f.file_master_type_id === 26).length > 0">
                            <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 26)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div v-if="files.filter(f => f.file_master_type_id === 26)[0].document_expiry_date !== null" class="d-inline-block align-middle cs_file_name"
                                 :class="[this.$moment(files.filter(f => f.file_master_type_id === 26)[0].document_expiry_date).isBefore() ? 'red_color' : '']">
                              Drivers Licence Back (Expires:&nbsp;{{ files.filter(f => f.file_master_type_id === 26)[0].document_expiry_date | formatDate }})<br>
                              <span v-if="this.$moment(files.filter(f => f.file_master_type_id === 26)[0].document_expiry_date).isBefore()" class="red_color font-weight-bold">
                              EXPIRED
                            </span>
                            </div>
                            <div v-else class="d-inline-block align-middle cs_file_name">Drivers Licence Back</div>
                          </div>
                          <div v-else class="r2w red_color">
                            <button @click.prevent="" class="btn orcaBtn grey_bg sm_btn r2w_btn disabled" disabled="disabled">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div class="d-inline-block align-middle cs_file_name">Drivers Licence Back<br>MISSING</div>
                          </div>
                        </div>
                        <div v-else class="r2w red_color font-weight-bold">MISSING</div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="form-group">
                        <h5 class="mb-0">Proof of ID</h5>
                        <!-- Passport -->
                        <div v-if="files.filter(f => f.file_master_type_id === 27).length > 0" class="r2w">
                          <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 27)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                            <i class="fas fa-eye"></i>
                          </button>
                          <div v-if="files.filter(f => f.file_master_type_id === 27)[0].document_expiry_date !== null" class="d-inline-block align-middle cs_file_name"
                               :class="[this.$moment(files.filter(f => f.file_master_type_id === 27)[0].document_expiry_date).isBefore() ? 'red_color' : '']">
                            Passport (Expires:&nbsp;{{ files.filter(f => f.file_master_type_id === 27)[0].document_expiry_date | formatDate }})<br>
                            <span v-if="this.$moment(files.filter(f => f.file_master_type_id === 27)[0].document_expiry_date).isBefore()" class="red_color font-weight-bold">
                              EXPIRED
                            </span>
                          </div>
                          <div v-else class="d-inline-block align-middle cs_file_name">Passport</div>
                        </div>
                        <!-- Biometric ID Front & Back -->
                        <div v-if="files.filter(f => f.file_master_type_id === 30).length > 0" class="r2w">
                          <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 30)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                            <i class="fas fa-eye"></i>
                          </button>
                          <div v-if="files.filter(f => f.file_master_type_id === 30)[0].document_expiry_date !== null" class="d-inline-block align-middle cs_file_name"
                               :class="[this.$moment(files.filter(f => f.file_master_type_id === 30)[0].document_expiry_date).isBefore() ? 'red_color' : '']">
                            Biometric ID Front & Back (Expires:&nbsp;{{ files.filter(f => f.file_master_type_id === 30)[0].document_expiry_date | formatDate }})<br>
                            <span v-if="this.$moment(files.filter(f => f.file_master_type_id === 30)[0].document_expiry_date).isBefore()" class="red_color font-weight-bold">
                              EXPIRED
                            </span>
                          </div>
                          <div v-else class="d-inline-block align-middle cs_file_name">Biometric ID Front & Back</div>
                        </div>
                        <!-- Biometric ID Front / Back -->
                        <div v-else-if="files.filter(f => f.file_master_type_id === 19).length > 0 || files.filter(f => f.file_master_type_id === 20).length > 0">
                          <!-- Front -->
                          <div class="r2w" v-if="files.filter(f => f.file_master_type_id === 19).length > 0">
                            <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 19)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div v-if="files.filter(f => f.file_master_type_id === 19)[0].document_expiry_date !== null" class="d-inline-block align-middle cs_file_name"
                                 :class="[this.$moment(files.filter(f => f.file_master_type_id === 19)[0].document_expiry_date).isBefore() ? 'red_color' : '']">
                              Biometric ID Front (Expires:&nbsp;{{ files.filter(f => f.file_master_type_id === 19)[0].document_expiry_date | formatDate }})<br>
                              <span v-if="this.$moment(files.filter(f => f.file_master_type_id === 19)[0].document_expiry_date).isBefore()" class="red_color font-weight-bold">
                                EXPIRED
                              </span>
                            </div>
                            <div v-else class="r2w red_color">Biometric ID Front</div>
                          </div>
                          <div v-else class="r2w red_color">
                            <button @click.prevent="" class="btn orcaBtn grey_bg sm_btn r2w_btn disabled" disabled="disabled">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div class="d-inline-block align-middle cs_file_name">Biometric ID Front<br>MISSING</div>
                          </div>
                          <!-- Back -->
                          <div class="r2w" v-if="files.filter(f => f.file_master_type_id === 20).length > 0">
                            <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 20)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div v-if="files.filter(f => f.file_master_type_id === 20)[0].document_expiry_date !== null" class="d-inline-block align-middle cs_file_name"
                                 :class="[this.$moment(files.filter(f => f.file_master_type_id === 20)[0].document_expiry_date).isBefore() ? 'red_color' : '']">
                              Biometric ID Back (Expires:&nbsp;{{ files.filter(f => f.file_master_type_id === 20)[0].document_expiry_date | formatDate }})<br>
                              <span v-if="this.$moment(files.filter(f => f.file_master_type_id === 20)[0].document_expiry_date).isBefore()" class="red_color font-weight-bold">
                                EXPIRED
                              </span>
                            </div>
                            <div v-else class="d-inline-block align-middle cs_file_name">Biometric ID Back</div>
                          </div>
                          <div v-else class="r2w red_color">
                            <button @click.prevent="" class="btn orcaBtn grey_bg sm_btn r2w_btn disabled" disabled="disabled">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div class="d-inline-block align-middle cs_file_name">Biometric ID Back<br>MISSING</div>
                          </div>
                        </div>
                        <div v-else >
                          <div v-if="files.filter(f => f.file_master_type_id === 27).length > 0" ></div>
                          <!-- show text 'missing' if no passport and no biometric -->
                          <div v-else class="r2w red_color font-weight-bold">MISSING</div>
                        </div>
                      </div>
                      <div class="form-group">
                        <h5 class="mb-0">Proof of Address</h5>
                        <!-- Address Document -->
                        <div v-if="files.filter(f => f.file_master_type_id === 28).length > 0" class="r2w">
                          <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 28)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                            <i class="fas fa-eye"></i>
                          </button>
                          <div class="d-inline-block align-middle cs_file_name">Address Document</div>
                        </div>
                        <!-- Drivers Licence Front & Back -->
                        <div v-else-if="files.filter(f => f.file_master_type_id === 29).length > 0" class="r2w">
                          <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 29)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                            <i class="fas fa-eye"></i>
                          </button>
                          <div v-if="files.filter(f => f.file_master_type_id === 29)[0].document_expiry_date !== null" class="d-inline-block align-middle cs_file_name"
                               :class="[this.$moment(files.filter(f => f.file_master_type_id === 29)[0].document_expiry_date).isBefore() ? 'red_color' : '']">
                            Drivers Licence Front & Back (Expires:&nbsp;{{ files.filter(f => f.file_master_type_id === 29)[0].document_expiry_date | formatDate }})<br>
                            <span v-if="this.$moment(files.filter(f => f.file_master_type_id === 29)[0].document_expiry_date).isBefore()" class="red_color font-weight-bold">
                              EXPIRED
                            </span>
                          </div>
                          <div v-else class="d-inline-block align-middle cs_file_name">Drivers Licence Front & Back</div>
                        </div>
                        <!-- Drivers Licence Front / Back -->
                        <div v-else-if="files.filter(f => f.file_master_type_id === 25).length > 0 || files.filter(f => f.file_master_type_id === 26).length > 0" class="r2w">
                          <!-- Front -->
                          <div class="r2w" v-if="files.filter(f => f.file_master_type_id === 25).length > 0">
                            <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 25)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div v-if="files.filter(f => f.file_master_type_id === 25)[0].document_expiry_date !== null" class="d-inline-block align-middle cs_file_name"
                                 :class="[this.$moment(files.filter(f => f.file_master_type_id === 25)[0].document_expiry_date).isBefore() ? 'red_color' : '']">
                              Drivers Licence Front (Expires:&nbsp;{{ files.filter(f => f.file_master_type_id === 25)[0].document_expiry_date | formatDate }})<br>
                              <span v-if="this.$moment(files.filter(f => f.file_master_type_id === 25)[0].document_expiry_date).isBefore()" class="red_color font-weight-bold">
                              EXPIRED
                            </span>
                            </div>
                            <div v-else class="d-inline-block align-middle cs_file_name">Drivers Licence Front</div>
                          </div>
                          <div v-else class="r2w red_color">
                            <button @click.prevent="" class="btn orcaBtn grey_bg sm_btn r2w_btn disabled" disabled="disabled">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div class="d-inline-block align-middle cs_file_name">Drivers Licence Front<br>MISSING</div>
                          </div>
                          <!-- Back -->
                          <div class="r2w" v-if="files.filter(f => f.file_master_type_id === 26).length > 0">
                            <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 26)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div v-if="files.filter(f => f.file_master_type_id === 26)[0].document_expiry_date !== null" class="d-inline-block align-middle cs_file_name"
                                 :class="[this.$moment(files.filter(f => f.file_master_type_id === 26)[0].document_expiry_date).isBefore() ? 'red_color' : '']">
                              Drivers Licence Back (Expires:&nbsp;{{ files.filter(f => f.file_master_type_id === 26)[0].document_expiry_date | formatDate }})<br>
                              <span v-if="this.$moment(files.filter(f => f.file_master_type_id === 26)[0].document_expiry_date).isBefore()" class="red_color font-weight-bold">
                              EXPIRED
                            </span>
                            </div>
                            <div v-else class="d-inline-block align-middle cs_file_name">Drivers Licence Back</div>
                          </div>
                          <div v-else class="r2w red_color">
                            <button @click.prevent="" class="btn orcaBtn grey_bg sm_btn r2w_btn disabled" disabled="disabled">
                              <i class="fas fa-eye"></i>
                            </button>
                            <div class="d-inline-block align-middle cs_file_name">Drivers Licence Back<br>MISSING</div>
                          </div>
                        </div>
                        <div v-else class="r2w red_color font-weight-bold">MISSING</div>
                      </div>
                      <div class="form-group">
                        <h5 class="mb-0">VISA</h5>
                        <!-- VISA Doc -->
                        <div v-if="files.filter(f => f.file_master_type_id === 24).length > 0" class="r2w">
                          <button @click.prevent="view_file_modal(files.filter(f => f.file_master_type_id === 24)[0].id)" class="btn orcaBtn greenBtn sm_btn r2w_btn">
                            <i class="fas fa-eye"></i>
                          </button>
                          <div v-if="files.filter(f => f.file_master_type_id === 24)[0].settlement_indefinite" class="d-inline-block align-middle cs_file_name">
                            VISA Doc (Indefinite Stay)
                          </div>
                          <div v-else-if="files.filter(f => f.file_master_type_id === 24)[0].settlement_expiry !== null" class="d-inline-block align-middle cs_file_name"
                               :class="[this.$moment(files.filter(f => f.file_master_type_id === 24)[0].settlement_expiry).isBefore() ? 'red_color' : '']">
                            VISA Doc (Expires:&nbsp;{{ files.filter(f => f.file_master_type_id === 24)[0].settlement_expiry | formatDate }})<br>
                            <span v-if="this.$moment(files.filter(f => f.file_master_type_id === 24)[0].settlement_expiry).isBefore()" class="red_color font-weight-bold">
                              EXPIRED
                            </span>
                          </div>
                        </div>
                        <div v-else class="r2w red_color font-weight-bold">MISSING</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 form-group" v-if="worker.person.nationality_id === null">
                    <div class="no_nationality">
                      NO NATIONALITY ON RECORD
                    </div>
                  </div>
                </div>
              </div>
              <!-- Compliance Test -->
              <div class="col-xl-6">
                <div class="row">
                  <div class="col-12" v-if="worker.rel_company_info.employment_type_id !== 33">
                    <h5 class="text-uppercase">Compliance Test</h5>
                    <div class="row ml-0 mr-0 mb-3" v-if="notEmptyObject(latest_compliance_test)">
                      <div class="col-12 latest_entity_test Fail mb-2" v-if="check_test_expiry()">
                        <button @click="new_entity_test" class="btn orcaBtn blueBtn sm_btn" data-toggle="tooltip" title="New Entity Test"><i class="fas fa-vial"></i> &nbsp; New
                        </button>
                        <div class="test_info font-weight-bold">TEST HAS EXPIRED</div>
                      </div>
                      <div class="col-12 latest_entity_test Amber mb-2" v-else-if="check_test_expiring()">
                        <button @click="new_entity_test" class="btn orcaBtn blueBtn sm_btn" data-toggle="tooltip" title="New Entity Test"><i class="fas fa-vial"></i> &nbsp; New
                        </button>
                        <div class="test_info font-weight-bold">TEST EXPIRES WITHIN 2 WEEKS</div>
                      </div>
                      <div class="col-12 latest_entity_test" :class="checkTest(latest_compliance_test) && !check_test_expiry()">
                        <button @click="view_entity_test(latest_compliance_test.id)" class="btn orcaBtn greenBtn sm_btn" data-toggle="tooltip" title="View Entity Test">
                          <i class="fas fa-eye"></i>
                        </button>
                        <span class="test_status">{{ checkTest(latest_compliance_test) }}</span>
                        <div class="test_info">
                          <span class="test_date"><span class="d-inline-block" style="width: 55px">Test date:</span> {{ latest_compliance_test.updated_at | formatDate }}</span>
                          <span class="test_date"><span class="d-inline-block" style="width: 55px">Expiry:</span> {{ latest_compliance_test.test_expiry | formatDate }}</span>
                          <span class="test_created_at">
                  By <span v-if="latest_compliance_test.created_log !== undefined
                      && latest_compliance_test.created_log !== null
                      && latest_compliance_test.created_log.log_by_type === 'App\\Models\\Users\\User'">:
                  {{ latest_compliance_test.created_log.log_by.first_name }} {{ latest_compliance_test.created_log.log_by.surname }}</span><span v-else>Worker</span>
                 </span>
                        </div>
                      </div>
                    </div>
                    <div class="row ml-0 mr-0" v-else>
                      <div class="col-12 latest_entity_test Fail mb-2">
                        <button @click="new_entity_test" class="btn orcaBtn blueBtn sm_btn" data-toggle="tooltip" title="New Entity Test"><i class="fas fa-vial"></i> &nbsp; New
                        </button>
                        <div class="test_info font-weight-bold">NO TEST COMPLETED</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
    <!-- Current Assignment(s) -->
    <div class="col-xl-4">
      <b-card header="Current Assignment(s)" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="row">
          <div class="col-10 offset-1 form-group">
            <button @click="new_assignment" class="btn orcaBtn sm_btn w-100"><i class="fas fa-plus"></i> New Assignment</button>
          </div>
        </div>
        <div v-if="notEmptyObject(current_assignments)" class="row">
          <div class="col-12 dash_ca_outer">
            <div v-for="(values, company) in current_assignments" class="dash_current_assignments_container">
              <h5 class="font-weight-bold bp_color">{{ company }}</h5>
              <div v-for="ass in values" class="dash_current_assignments">
                <div class="dca_content">
                  <strong class="d-block" style="font-size: 0.9rem;">{{ ass.order_job.rel_order_position.job_title }} [{{ ass.order_ref }}]</strong>
                  <span class="mb-2 d-block">{{ ass.order_job.rel_order_location.job_address_full }}</span>
                  <strong>{{ ass.position_rate.pay_amount | currency }} ({{ ass.position_rate.pay_type }})</strong>
                  -- [{{ ass.start_date | formatDate }}&nbsp;-&nbsp;{{ ass.end_date | formatDate }}]<br>
                  <span v-if="ass.gang_leader_id !== null">Gang Leader : {{ ass.gang_leader.person.first_name }} {{ ass.gang_leader.person.surname }}</span>
                  <span class="dca_assigned">{{ ass.assigned_by.first_name }} {{ ass.assigned_by.surname }} as {{ ass.created_at | formatDateTime }}</span>
                </div>
                <div class="dca_icons">
                  <div class="dca_gl" v-if="ass.is_gang_leader"><i class="fas fa-crown"></i></div>
                  <!--                  <div class="dca_edit">-->
                  <!--                    <button @click="" class="btn orcaBtn blueBtn" data-toggle="tooltip" title="Edit Assignment">-->
                  <!--                      <i class="fas fa-edit"></i>-->
                  <!--                    </button>-->
                  <!--                  </div>-->
                  <div class="dca_end">
                    <button @click="" class="btn orcaBtn danger" data-toggle="tooltip" title="End Assignment">
                      <i class="fas fa-stop"></i>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div v-else class="row">
          <div class="col-12">
            <div style="border: 1px dashed #666666; padding: 10px;" class="mb-3">
              <h5 class="text-center mb-0 text-uppercase">Currently not assigned</h5>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <!-- Notes -->
    <div class="col-12">
      <b-card header="Notes" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="notes_datatable">
          <datatable :type="'notes'" :recordType="'company'" :rowData="notes" :loadingMessage="loadingMessage" :noRowsMessage="noRowsMessage" :columns="columns"></datatable>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import datatable from "datatables/datatable";

export default {
  name: "worker_dashboard",
  components: {datatable},
  props: ['worker', 'tax_hmrc', 'files', 'notes', 'notes_loaded'],
  data() {
    return {
      // Set Genius PA Insurance value from env file
      pa_ins: process.env.MIX_PA_INS,
      latest_compliance_test: {},
      current_assignments: {},
      uk_ireland: ['United Kingdom (UK)', 'Wales', 'Scotland', 'Northern Ireland', 'England', 'Republic of Ireland'],
      eu: ['Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic', 'Denmark', 'Estonia', 'Finland', 'France', 'Germany', 'Greece',
        'Hungary', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'The Netherlands', 'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden'],
      // NOTES
      loadingMessage: 'Loading Notes...',
      noRowsMessage: 'No Notes Found',
      columns: [
        { headerName: 'Date', valueGetter: this.noteDate, maxWidth: 150 },
        { headerName: 'Type', field: 'note_type', maxWidth: 150 },
        { headerName: 'Left By', field: 'logged_by_name', maxWidth: 150 },
        { headerName: 'Note', field: 'note_description', minWidth: 200 },
        { headerName: 'Note On', valueGetter: this.noteSubject, maxWidth: 200 },
      ],
    }
  },
  beforeMount() {
    // latest compliance test
    axios.get(this.crmApiPath + 'worker/compliance_test/worker/' + this.worker.id + '/latest').then(worker_compliance_test => {
      if (worker_compliance_test !== undefined && worker_compliance_test !== null) {
        this.latest_compliance_test = worker_compliance_test.data;
      }
      this.entity_test_loaded = true;
    }).catch(error => console.log(error.response));
    // get current assignments for the worker
    axios.get(this.crmApiPath + 'assignments/worker/dashboard/current_assignments/' + this.worker.id).then(current_assignments => {
      if (current_assignments.data !== "") {
        this.current_assignments = current_assignments.data
      }
    })
  },
  methods: {
    noteDate(params) {
      return this.$options.filters.formatDateTime(params.data.note_updated_at || params.data.note_date);
    },

    noteSubject(params) {
      // if note is against a contact
      if (params.data.contact_id && params.data.contact_name) {
        return `Contact (${params.data.contact_name})`;
      }

      // worker note?
      if (params.data.worker_id && params.data.worker_name) {
        return `Worker (${params.data.worker_name})`;
      }

      return 'Company';
    },
    // FILES
    view_file_modal(file_id) {
      this.$store.commit('SHOW_VIEW_FILE_MODAL', {
        id: file_id,
        type: 'worker'
      });
      this.$store.state.files.view_modal = true;
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_file_modal'));
    },
    // COMPLIANCE TEST
    check_test_expiry() {
      let now = this.$moment().format('YYYY-MM-DD')
      return this.$moment(now).isAfter(this.$moment(this.latest_compliance_test.test_expiry));
    },
    check_test_expiring() {
      // test is expiring within two weeks
      let now = this.$moment().format('YYYY-MM-DD')
      let two_weeks_before_expiry = this.$moment(this.latest_compliance_test.test_expiry).subtract(2, 'week')
      return this.$moment(now).isAfter(two_weeks_before_expiry);
    },
    view_entity_test() {
      this.$emit('update_tab', 4)
    },
    new_entity_test() {
      this.$store.commit('CURRENT_NEW_ENTITY_TEST_WORKER_ID', this.worker.id);
      this.$nextTick(() => this.$router.push('/workers/entity_test/new'));
    },
    new_assignment() {
      this.$store.commit('CURRENT_NEW_ASSIGNMENT_WORKER_ID', {
        worker_id: this.worker.id,
        compliance_test_id: null
      });
      // Open up worker assignment
      this.$nextTick(() => {
        this.$router.push('/workers/assignment');
        this.$tabs.refresh('/workers/assignment', true);
      });
    },
    // NOTES
    date_value_getter(params) {
      return this.$options.filters.formatDateTime(params.data.updated_at);
    },
    left_by_vg(params) {
      return params.data.note_log_by.first_name + ' ' + params.data.note_log_by.surname;
    }
  }
}
</script>

<style scoped lang="scss">
.dash_ca_outer {
  max-height: 359px;
  overflow:   scroll;
}

.uk_citizen {
  border:        2px solid $green;
  border-radius: $border_radius_2;
  padding:       5px;
  color:         $green;
  font-weight:   bold;
  text-align:    center;
}

.nation {
  border:         1px solid $bc_2;
  border-radius:  $border_radius_2;
  text-align:     center;
  padding:        5px;
  display:        inline-block;
  width:          35px;
  vertical-align: top;
  margin-right:   10px;
}

.no_nationality {
  background:    $red;
  color:         $white;
  padding:       10px;
  border-radius: $border_radius_2;
  font-weight:   bold;
}

.r2w {
  margin-top: 5px;

  .cs_file_name {
    width: calc(100% - 85px);
  }
}

.r2w_btn {
  width:        auto;
  height:       auto;
  padding:      5px 8.5px;
  font-size:    0.5rem;
  line-height:  inherit;
  margin-right: 10px;
}

.dash_current_assignments_container {
  .dash_current_assignments {
    background:    darken($card_background, 5%);
    padding:       10px;
    margin-bottom: 10px;
    margin-left:   10px;

    &:last-of-type {
      margin-bottom: 15px;
    }

    .dca_content {
      display: inline-block;
      width:   calc(100% - 35px);

      .dca_assigned {
        font-size:  0.6rem;
        font-style: italic;
      }
    }

    .dca_icons {
      float: right;

      .dca_gl {
        display:       inline-block;
        padding:       3px 5px;
        background:    $orange;
        color:         $white;
        font-size:     0.65rem;
        margin-bottom: 10px;
      }

      .dca_edit, .dca_end {
        .orcaBtn {
          width:         auto;
          height:        auto;
          padding:       5px 8.5px;
          font-size:     0.5rem;
          line-height:   inherit;
          margin-bottom: 10px;
        }
      }

      .dca_edit {
        .orcaBtn {
          padding: 5px 7.5px;
        }
      }
    }
  }
}

.latest_entity_test {
  margin-bottom: 0;
  padding-left:  7px;
  padding-right: 7px;

  &.Fail, &.Amber, &.Pass {
    color:          $white;
    padding-top:    5px;
    padding-bottom: 5px;
  }

  &.Fail {
    background: $red;
  }

  &.Amber {
    background: $orange;
  }

  &.Pass {
    background: $green;

    .orcaBtn {
      border: white 1px solid;
    }
  }

  //&.Pass {
  //  .test_status {
  //    color: $green;
  //  }
  //}

  button {
    float:          none;
    vertical-align: middle;
    margin-right:   10px;
  }

  .test_status {
    width:          70px;
    display:        inline-block;
    vertical-align: middle;
    line-height:    1.1;
    font-weight:    bold;
    font-size:      1rem;
    text-transform: uppercase;
  }

  .test_info {
    width:          calc(100% - 130px);
    display:        inline-block;
    vertical-align: middle;

    .test_date, .test_created_at {
      line-height: 1.1;
      display:     block;
      font-size:   0.625rem;
    }

    .test_date {
      font-weight: bold;
    }

    .test_created_at {
      margin-top: 3px;
    }
  }
}

.notes_datatable {
  .full_height_datatable {
    height: 600px;
  }
}
</style>
